import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

import { styles } from './styles'
import Title from '../../components/Title'
import HeroDocument from '../../components/HeroDocument'
import { withContext } from '../../context'

export const AccountDocument = ({
  history: { goBack },
  context: { state },
  me
}) => {
  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            รูปภาพและเอกสาร
          </Typography>
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      <Title name="รูปภาพและเอกสาร" />
      <HeroDocument me={me}/>
    </React.Fragment>
  )
}

AccountDocument.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(withRouter, withContext)(AccountDocument)



// WEBPACK FOOTER //
// ./src/pages/AccountDocument/index.js